import {initDetailByAPI} from '@web/actions/detail'
import {APIStatus, OrderPhase} from '@web/core/constants'
import {getSaleChannelType} from '@web/slices/common/slice'
import makeSlice from '@web/slices/common/sliceMaker'

const commonSlice = makeSlice({
    extraReducers: (builder) => {
        builder
            .addCase(initDetailByAPI.pending, (state) => {
                state.scene = APIStatus.FETCHING
            })
            .addCase(initDetailByAPI.fulfilled, (state, {payload}) => {
                state.scene = APIStatus.RESOLVED
                const {order} = payload.data
                state.entry = getSaleChannelType(order.saleChannelType, order.scheduledChannelType)
                state.orderPhase = OrderPhase.DETAIL
                state.seqID = order.orderNo
            })
            .addCase(initDetailByAPI.rejected, (state) => {
                state.scene = APIStatus.REJECTED
            })
    },
})

export default commonSlice.reducer
